import { createAction } from 'redux-act';

export const customerReceived = createAction('Customer received', customer => customer);